import {
  EMPLOYEE_LOOKUP_PENDING,
  EMPLOYEE_LOOKUP_SUCCESS,
  EMPLOYEE_LOOKUP_FAIL,
} from "../../actions/types";

const initialState = {
  lookups: {
    departments: [],
    designations: [],
    teams: [],
    cities: [],
    roles: [],
    inactiveEmployees: [],
    employmentStatuses: [],
    officeLocations: [],
    genders: [],
  },
  isEmployeeLookupLoading: false,
  error: null,
};

const employeeLookupReducer = (state = initialState, action) => {

  switch (action.type) {
    case EMPLOYEE_LOOKUP_PENDING:
      return {
        ...state,
        isEmployeeLookupLoading: true,
        error: null,
      };

    case EMPLOYEE_LOOKUP_SUCCESS: {
      const lookup = action.payload.lookups; // ✅ FIXED LINE
       const data =  {
        ...state,
        isEmployeeLookupLoading: false,
        lookups: {
          departments: lookup.departments || [],
          designations: lookup.designations || [],
          teams: lookup.teams || [],
          cities: lookup.cities || [],
          roles: lookup.roles || [],
          inactiveEmployees: lookup.inactiveEmployees || [],
          employmentStatuses: lookup.employmentStatuses || [],
          officeLocations: lookup.officeLocations || [],
          genders: lookup.genders || [],
        },
      };
      return data;
    }

    case EMPLOYEE_LOOKUP_FAIL:
      return {
        ...state,
        lookups: initialState.lookups,
        isEmployeeLookupLoading: false,
        error: "Failed to fetch employee lookup data",
      };

    default:
      return state;
  }
};

export default employeeLookupReducer;
